const TableCellListOfEnum = ({ enumDict, value }) => {
  return (
    <div className="table-cell-enum">
      {value?.map((e) => enumDict[e]).join()}
    </div>
  );
};

export default TableCellListOfEnum;
